import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type {
  IApiGetOnboardingStatusRequestBody,
  IApiGetOnboardingStatusResponseBody,
} from '../OnboardingApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseOnboardingStatusQueryValues = {
  body: IApiGetOnboardingStatusRequestBody;
};

export const onboardingStatusQueryKeyFactory: IQueryKeyFactory<
  IUseOnboardingStatusQueryValues
> = (values) => values && (['onboardingStatus', values.body] as const);

export const useOnboardingStatusQuery = (
  values?: IUseOnboardingStatusQueryValues,
  options?: UseQueryOptions<IApiGetOnboardingStatusResponseBody, ApiError>,
): UseQueryResult<IApiGetOnboardingStatusResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: onboardingStatusQueryKeyFactory(values),
    queryFn: values ? () => api.onboarding.getStatus(values.body) : undefined,
    enabled: !!values,
    ...options,
  });
};
